import Axios from '@/api/http'

/**
 * 新增分类
 * */
export function openapiAddoptioncategory(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addoptioncategory',
    data: date
  })
}
/**
 * 修改分类
 * */
export function openapiUpdateoptioncategory(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateoptioncategory',
    data: date
  })
}
/**
 * 删除分类
 * */
export function openapiDeleteoptioncategory(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteoptioncategory',
    data: date
  })
}
/**
 * 查找字典分类列表
 * */
export function openapiGetoptioncategorylist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getoptioncategorylist',
    data: date
  })
}
/**
 * 新增选项
 * */
export function openapiAddoptions(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addoptions',
    data: date
  })
}
/**
 * 修改选项
 * */
export function openapiUpdateoptions(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateoptions',
    data: date
  })
}
/**
 * 查找选项列表
 * */
export function openapiGetoptionslist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getoptionslist',
    data: date
  })
}
/**
 * 查找字典列表详情
 * */
export function openapiGetoptions(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getoptions',
    data: date
  })
}
/**
 * 删除选项
 * */
export function openapiDeleteoptions(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteoptions',
    data: date
  })
}
/**
 * 拖拉修改字典分类排序
 * */
export function openapiBatchupdateoptioncategoryorders(date) {
  return Axios({
    method: 'post',
    url: '/openapi/batchupdateoptioncategoryorders',
    data: date
  })
}
